var map = {
	"./en/main-view-logo.png": 4569,
	"./zh-CN/main-view-logo.png": 7004,
	"./zh-HK/main-view-logo.png": 9656,
	"./zh-TW/main-view-logo.png": 4000,
	"./zh/main-view-logo.png": 8084
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3747;